import React from 'react';
import clsx from 'clsx';
import BlockWrapper from '@/layouts/BlockWrapper/BlockWrapper.component'; // Corrected import
import ContentWrapper, {
    ContentColumn,
} from '@/layouts/ContentWrapper/ContentWrapper.component'; // Corrected import
import Image from '@/elements/Image/Image.component'; // Corrected import
import Heading from '@/elements/Heading/Heading.component'; // Corrected import
import Text from '@/elements/Text/Text.component'; // Corrected import
import { IProps } from './FiftyFiftyImageBlock.interface';
import './FiftyFiftyImageBlock.styles.css';
import Button from '@/elements/Button/Button.component';

const FiftyFiftyImageBlock: React.FC<IProps> = ({
    className,
    image,
    caption,
    heading,
    text,
    buttons,
    mediaPosition = 'left',
    ...blockWrapperProps
}) => {
    const imageColOrder = clsx({
        'order-2': true, // Image is always second on mobile
        'md:order-1': mediaPosition === 'left',
        'md:order-2': mediaPosition === 'right',
    });

    const textColOrder = clsx({
        'order-1': true, // Text is always first on mobile
        'md:order-2': mediaPosition === 'left',
        'md:order-1': mediaPosition === 'right',
    });

    return (
        <BlockWrapper
            className={clsx('fiftyFiftyImageBlock', className, {
                'fiftyFiftyImageBlock--mediaLeft': mediaPosition === 'left',
                'fiftyFiftyImageBlock--mediaRight': mediaPosition === 'right',
            })}
            {...blockWrapperProps}
        >
            <ContentWrapper>
                {/* Text Column */}
                <ContentColumn
                    className={clsx('fiftyFiftyImageBlock__textColumn', textColOrder)}
                >
                    {heading && (
                        <Heading
                            level={2}
                            className="fiftyFiftyImageBlock__heading"
                            html={heading}
                        />
                    )}

                    {text &&
                        <Text
                            className="fiftyFiftyImageBlock__text"
                            html={text}
                        />
                    }

                    {buttons && (
                        <div className="fiftyFiftyImageBlock__buttons">
                            {buttons.map((button, index) => (
                                <Button
                                    key={`fifty-fifty-image-cta-${index}`}
                                    {...button}
                                    className={clsx(
                                        'fiftyFiftyImageBlock__button',
                                        button.className,
                                    )}
                                >
                                    {button.children}
                                </Button>
                            ))}
                        </div>
                    )}
                </ContentColumn>

                {/* Image Column */}
                <ContentColumn
                    className={clsx('fiftyFiftyImageBlock__imageColumn', imageColOrder)}
                >
                    {image && <Image {...image} className='fiftyFiftyImageBlock__image' rounded={true} />}
                    {caption && (
                        <Text className="fiftyFiftyImageBlock__caption" html={caption} />
                    )}
                </ContentColumn>
            </ContentWrapper>
        </BlockWrapper>
    );
};

export default FiftyFiftyImageBlock;
export { FiftyFiftyImageBlock };
